(function () {
  'use strict';
  /* Search and two filters (job, industry). Progressive enhancement: without this script the tools stay hidden and every card is listed. */
  var grid = document.getElementById('uc-grid');
  if (!grid) return;
  var tools = document.querySelector('[data-uc-tools]');
  if (tools) tools.hidden = false;
  /* every card of the directory: all 62 sit in #uc-grid (on a phone ow-uc-more.js shows the first eight and a "Show all 62" row) */
  var dir = grid.closest('.uc-dir') || document;
  var cards = [].slice.call(dir.querySelectorAll('.uc-card'));
  var qIn = document.getElementById('uc-q');
  var jobBtns = [].slice.call(document.querySelectorAll('[data-uc-job]'));
  var wsBtns = [].slice.call(document.querySelectorAll('[data-uc-ws]'));
  var count = document.getElementById('uc-count');
  var empty = document.getElementById('uc-empty');
  var reset = document.querySelector('[data-uc-reset]');
  var total = cards.length;
  var state = { q: '', job: 'all', ws: 'all' };
  function norm(s) { return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
  cards.forEach(function (c) { c.__q = norm(c.getAttribute('data-q')); });

  function apply() {
    var toks = norm(state.q).split(' ').filter(Boolean), shown = 0;
    cards.forEach(function (c) {
      var ws = c.getAttribute('data-ws');
      var ok = (state.job === 'all' || c.getAttribute('data-job') === state.job) &&
               (state.ws === 'all' || ws === state.ws || ws === 'all') &&
               toks.every(function (t) { return c.__q.indexOf(t) > -1; });
      c.hidden = !ok;
      if (ok) shown++;
    });
    jobBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-uc-job') === state.job)); });
    wsBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-uc-ws') === state.ws)); });
    /* no partial last row: the last card shown spans what is left of its row (full width when it sits alone), at 3 columns and at 2. The CSS reads data-r3 and data-r2. */
    var lastShown = null;
    cards.forEach(function (c) { c.removeAttribute('data-uc-last'); if (!c.hidden) lastShown = c; });
    if (lastShown) lastShown.setAttribute('data-uc-last', '');
    grid.setAttribute('data-r3', String(shown % 3));
    grid.setAttribute('data-r2', String(shown % 2));
    if (count) count.textContent = (shown === total ? total : shown + ' of ' + total) + ' use cases';
    if (empty) empty.hidden = shown !== 0;
    grid.hidden = shown === 0;
    window.__ucActive = !!norm(state.q) || state.job !== 'all' || state.ws !== 'all';   /* ow-uc-more.js keeps the rest of the list open on a phone while a search or filter is active */
    document.dispatchEvent(new CustomEvent('uc:filter'));
  }
  if (qIn) {
    var onQ = function () { state.q = qIn.value; apply(); };
    qIn.addEventListener('input', onQ);
    qIn.addEventListener('search', onQ);
  }
  jobBtns.forEach(function (b) { b.addEventListener('click', function () { state.job = b.getAttribute('data-uc-job'); apply(); }); });
  wsBtns.forEach(function (b) { b.addEventListener('click', function () { state.ws = b.getAttribute('data-uc-ws'); apply(); }); });
  if (reset) reset.addEventListener('click', function () {
    state = { q: '', job: 'all', ws: 'all' };
    if (qIn) { qIn.value = ''; qIn.focus(); }
    apply();
  });
  /* a link such as use-cases.html#marketing or use-cases.html#home-services starts with that chip chosen */
  function fromHash() {
    var h = (location.hash || '').replace(/^#/, '');
    if (h && jobBtns.some(function (b) { return b.getAttribute('data-uc-job') === h; })) state.job = h;
    else if (h && wsBtns.some(function (b) { return b.getAttribute('data-uc-ws') === h; })) state.ws = h;
    else return false;
    return true;
  }
  fromHash();
  window.addEventListener('hashchange', function () { if (fromHash()) apply(); });
  apply();
})();
